import { render } from "./CloudHeader.vue?vue&type=template&id=2a23b264&scoped=true"
import script from "./CloudHeader.vue?vue&type=script&lang=js"
export * from "./CloudHeader.vue?vue&type=script&lang=js"

import "./CloudHeader.vue?vue&type=style&index=0&id=2a23b264&scoped=true&lang=css"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a23b264"]])

export default __exports__